import moment from 'moment';
import { INTERNAL_DATE } from '../constants/dates';

export const getFirstFriday = () => {
  const now = moment();
  if (now.isoWeekday() !== 5) {
    now.isoWeekday(5);
  }
  if (now.hour() >= 12) {
    now.add(7, 'day');
  }

  return now.format(INTERNAL_DATE);
};
